export const mdmAddActivitySiteCoreKeys = {
  createNewActivityHeader: "Activity.ActivityDetails.CreateNewActivityHeader",
  activityDetailsKey: "MDM.Activity.ActivityDetails",
  unitsList: "Activity.ActivityDetails.UnitsList",
  units: "Activity.ActivityDetails.Units",
  activityName: "Activity.ActivityDetails.ActivityName",
  modality: "Activity.ActivityDetails.Modality",
  programFramework: "Activity.ActivityDetails.ProgramFramework",
  modalityList: "Activity.ActivityDetails.ModalityList",
  saveActivity: "Activity.ActivityDetails.SaveActivity",
  selectedModality: "Activity.ActivityDetails.SelectedModality",
  selectedProgramFramework: "Activity.ActivityDetails.SelectedProgramFramework",
  activityCreatedMessage: "Activity.ActivityDetails.ActivityCreatedmessage",
  viewActivityHeader: "Activity.ActivityDetails.ViewActivityHeader",
  editActivityLink: "Activity.ActivityDetails.EditActivityLink",
  editActivityHeader: "Activity.ActivityDetails.EditActivityHeader",
  updateActivityButton: "Activity.ActivityDetails.UpdateActivityButton",
  updateActivityChangesMessage:
    "Activity.ActivityDetails.UpdateActivityChangesMessage",
  modifiedUnitAlertMessage: "Activity.ActivityDetails.ModifiedUnitAlertMessage",
  updateUnitValuesMessage: "Activity.ActivityDetails.UpdateUnitValuesMessage",
  activityUpdatedMessage: "Activity.ActivityDetails.ActivityUpdatedMessage",
  activityNameAlreadyExistsMessage:
    "Activity.ActivityDetails.ActivityNameAlreadyExistsMessage",
  selectedProjectFramework: "Activity.ActivityDetails.SelectedProjectFramework",
  projectFramework: "Activity.ActivityDetails.ProjectFramework",
  selectFrameworkType: "Activity.ActivityDetails.SelectFrameworkType",
  programRadioButton: "Activity.ActivityDetails.ProgramFrameworkRadioButton",
  projectRadioButton: "Activity.ActivityDetails.ProjectFrameworkRadioButton",
  areYouSureYouWantToChangeTheFrameworkType:
    "Activity.ActivityDetails.AreYouSureYouWantToChangeTheFrameworkType",
  modifyUOMInlineErrorMessage:
    "Activity.ActivityDetails.ModifyUOMInlineErrorMessage",

  //topic
  topicListKey: "MDM.Activity.TopicList",
  addTopicLink: "Activity.TopicList.AddTopicLink",
  addAtLeastOneTopicMessage: "Activity.TopicList.AddAtLeastOneTopicMessage",
  deleteTopicConfirmationMessage:
    "Activity.TopicList.DeleteTopicConfirmationMessage",
};

export const mdmAddActivityTopicSiteCoreKeys = {
  topicListKey: "MDM.Activity.TopicList",
  noTopicsAvailableMessage: "Activity.TopicList.NoTopicsAvailableMessage",
  topicColumn: "Activity.TopicList.Topic-Column",
  deliverables: "Activity.TopicList.Deliverables",
  activityStatus: "Activity.TopicList.ActivityStatus",
  minutesList: "Activity.TopicList.MinutesList",
  participantStatusList: "Activity.TopicList.ParticipantStatusList",
  actions: "Activity.TopicList.Actions",
  preferences: "Activity.TopicList.Preferences",
  selectedDeliverables: "Activity.TopicList.SelectedDeliverables",
  exceptions: "Activity.TopicList.Exceptions",
  selectedPreferences: "Activity.TopicList.SelectedPreferences",
  participantStatus: "Activity.TopicList.ParticipantStatus",
  activityStatusList: "Activity.TopicList.ActivityStatusList",
  unitList: "Activity.TopicList.UnitsList",
  minutesLabel: "Activity.TopicList.Minutes",
  quantityLabel: "Activity.TopicList.Quantity",
  numberOfDaysLabel: "Activity.TopicList.NumberOfDays",
  localeLabel: "Activity.TopicList.Locale",
  countTowardsLastContactDate: "Activity.TopicList.CountTowardsLastContactDate",
  triggerBilling: "Activity.TopicList.TriggerBilling",
  triggerTouchPointSurvey: "Activity.TopicList.TriggerTouchPointSurvey",
  measurement: "Activity.TopicList.Measurement",
  units: "Activity.TopicList.Units",
};
